// extracted by mini-css-extract-plugin
export var actionButton = "_ba-1";
export var actionButtons = "_ba-2";
export var actions = "_ba-0";
export var aiUnread = "_ba-10";
export var alignCenter = "_ba-h";
export var backWrapper = "_ba-3";
export var cellContainer = "_ba-4";
export var checkboxContainer = "_ba-5";
export var contentContainer = "_ba-6";
export var contentHeader = "_ba-8";
export var conversationsTableWrapper = "_ba-s";
export var draftReplyBadgeContainer = "_ba-m";
export var dropdownItem = "_ba-b";
export var dropdownItemsContainer = "_ba-a";
export var dropdownTitle = "_ba-c";
export var errorIcon = "_ba-7";
export var filter = "_ba-d";
export var gray = "_ba-i";
export var headerActionButtons = "_ba-e";
export var headerCheckboxContainer = "_ba-f";
export var icon = "_ba-j";
export var menuContainer = "_ba-k";
export var noMoreTicketsIcon = "_ba-12";
export var noMoreTicketsSubText = "_ba-13";
export var oneLine = "_ba-l";
export var optionsButton = "_ba-n";
export var plus = "_ba-o";
export var portalButtonsWrapper = "_ba-g";
export var red = "_ba-p";
export var scrolledTop = "_ba-9";
export var search = "_ba-q";
export var selectedConversationsCount = "_ba-r";
export var spinner = "_ba-t";
export var strong = "_ba-u";
export var summaryCell = "_ba-v";
export var tableContainer = "_ba-11";
export var tagContainer = "_ba-w";
export var threeDots = "_ba-x";
export var twoLines = "_ba-y";
export var unread = "_ba-z";